import { HospitalScheduleTemplateListingModel } from '../HospitalScheduleTemplateListingModel';

/**
 * An extension on the original HospitalScheduleTemplateListingModel that is used just for GetHospitalSchedule requests and includes whether the template
 * is on a schedule or not.  False means it's not on any requested hospital schedule in the request, true means it's scheduled.
 * Because templates are unique to hospitals this means if it's true it means it's scheduled at that hospital.  This prevents needing to do deep lookups in scheduledEntities to look for it
 * since the templates are returned on the root of the ProcessHospitalScheduleModel
 */
export class ScheduleHospitalScheduleTemplateListingModel extends HospitalScheduleTemplateListingModel {
  isScheduled: boolean;

  constructor(init: ScheduleHospitalScheduleTemplateListingModel) {
    super(init);
    this.isScheduled = init.isScheduled ? true : false;
  }
}
